import { render, staticRenderFns } from "./homeChart.vue?vue&type=template&id=b24a70c6&scoped=true&"
import script from "./homeChart.vue?vue&type=script&lang=js&"
export * from "./homeChart.vue?vue&type=script&lang=js&"
import style0 from "./homeChart.vue?vue&type=style&index=0&id=b24a70c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24a70c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
